module.exports = __webpack_public_path__ + "static/media/EYInterstate-Regular.f4aa49c9.ttf";